import React, { Component } from 'react';
import Select from 'react-select';
import PopUp from '../../../commonModules/interface/PopUp';
import Currency from '../../../commonModules/Currency';
import InputText from '../../../commonModules/interface/form-input-inline';
import Dialog, { CalendarDialog } from '../../../commonModules/interface/Dialog';
import Photos from '../../../commonModules/interface/input-files';
import { TableRow, TableCell, Table, TableHead, TableBody, TableContainer, Box, Button, IconButton } from '@material-ui/core';
import { TableLayout } from '../Stock/containers/Layout';
import { CheckRounded } from '@material-ui/icons';

// const SPENDINGS = [
//     {timeAction: Date.now(), action: "Maintenance", agent: "Kani", user: "client1", amount: "5000", actionStatus: "Payed", paymentDate: Date.now() },
//     {timeAction: Date.now(), action: "Commission Vente", agent: "Toto", user: "client8", amount: "15000", actionStatus: "Payed", paymentDate: Date.now() },
//     {timeAction: Date.now(), action: "Commission Installation", agent: "Pépé", user: "client4", amount: "2000", actionStatus: "WaitingPayment", paymentDate: Date.now() },
// ]
const ACTIONS = {
    VisitQuotation : "Visite de Site (Devis)",
    WaitingPayment : "En Attente de Paiement",

}
class SpendingList extends Component {
    state = { 
        selectedType: "",
        selectedTypeDisplay: "",
        updateStatus: false,
        spending: {},
        calendar: false,
        update_date: new Date(),
        files: null,

    }
    createSpendingList = () => {
        const { SPENDINGS, headerMenu } = this.props;
        const { selectedType } = this.state;
        // return SPENDINGS.map( spending => {
        return Object.values(SPENDINGS[headerMenu]).map( (spending, i) => {
            if ( (!selectedType) || (spending.action === selectedType)){
                return (
                    <TableRow key={`${spending.timeAcion}-${i}`} hover>
                        <TableCell>{new Date(spending.timeAction).toLocaleString("fr-FR")}</TableCell>
                        <TableCell>{spending.agent}</TableCell>
                        <TableCell>{ACTIONS[spending.action] || spending.action}</TableCell>
                        <TableCell>{spending.user}</TableCell>
                        <TableCell><Currency value={spending.amount} /></TableCell>
                        <TableCell>{ACTIONS[spending.actionStatus] || spending.actionStatus}</TableCell>
                        <TableCell>{spending.actionStatus === "Payed" && new Date(spending.paymentDate).toLocaleString("fr-FR")}</TableCell>
                        {/* <TableCell>{spending.extraInfo}</TableCell> */}
                        <TableCell>{spending.actionStatus !== "Payed" && 
                            <IconButton 
                                color="secondary" 
                                className="btn btn-warning" 
                                onClick={() => this.setState({ updateStatus: true, spending })} 
                                title="Valider le Paiement"
                            >
                                <CheckRounded />
                            </IconButton> 
                        }</TableCell>
                    </TableRow>
                )   
            }
        })
    }

    handleSubmit = () => {
        let data = { 
            new_status : "Payed",
            old_status : this.state.spending.actionStatus,
            update_date : this.state.update_date,
            files : this.state.files,
        } 
        this.props.updateSpending(data)
    }

    handleChangeDate = (update_date) => {
        this.setState({
            update_date
        })
    }
    setFiles = (list) => {
        console.log("[INFO] SETFILES", list);
        this.setState({
            files:list  
        })
    }
    render() {
        const { spending, updateStatus, calendar } = this.state;

        const typeList = [
            {value: "", label: "Choisissez un type de Dépense"},
            {value: "Commission Vente", label: "Commission Vente"},
            {value: "Commission Installation", label: "Commission Installation"},
            {value: "Maintenance", label: "Maintenance"}, // dont dispossess
            {value: "VisitQuotation", label: "Visite de site"}, // dont dispossess
            {value: "SMS", label: "SMS"},
            {value: "Appel", label: "Appel"},
        ]

        // let submit = (
        //     <button 
        //         className="btn btn-success" 
        //         onClick={this.handleSubmit} >
        //         Valider
        //     </button>
        // )
        return (
            <Box p={2}>
                {updateStatus && spending && 
                    <Dialog 
                        block={true}
                        title="Mettre à jour la dépense" 
                        close={ () => this.setState({ updateStatus: false, spending: {} })}
                        // submit={submit}
                        submitAction={this.handleSubmit}
                    >
                        <div>
                            {calendar && 
                                <CalendarDialog 
                                    selected={this.state.update_date}
                                    handleChangeDate={(date) => this.handleChangeDate(date)}
                                    close={ () => this.setState({ calendar: false })} 
                                    noMin
                                />
                            }
                            <InputText 
                                id="update_date" 
                                // className="input-sm form-control" 
                                value={(this.state.update_date).toLocaleDateString("fr-FR")} 
                                name="update_date" 
                                onClick={() => this.setState({ calendar: true }) } 
                                label="Date de Paiement"
                            />
                            {/* <div className="form-group ">
                                <label htmlFor="update_date" className="col-sm-12" >Date de Paiement</label>
                                <div className="col-sm-12">
                                    <div className="fg-line ">
                                        <small className="help-block">{error}</small>
                                    </div>
                                </div>
                            </div> */}
                            <div className="form-group">
                                <label>Justificatif(s)</label>
                                <Photos 
                                    photoList={this.setFiles} 
                                    photos={this.state.files === null ? [] : this.state.files } 
                                    file 
                                />
                            </div>

                            
                        </div>
                    </Dialog>
                }
            
                <Select
                    options={typeList}
                    className="form-control"
                    value={this.state.selectedTypeDisplay}
                    placeholder="Choisissez un Type de Dépense"
                    onChange={(option) => this.setState({ selectedType: option.value, selectedTypeDisplay:option }) }
                    style={{border: '0'}}
                    selectedValue={this.state.selectedTypeDisplay}
                />
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell component="th">Date</TableCell>
                            <TableCell component="th">Agent</TableCell>
                            <TableCell component="th">Prestation</TableCell>
                            <TableCell component="th">Type</TableCell>
                            <TableCell component="th">Montant</TableCell>
                            <TableCell component="th">Statut</TableCell>
                            <TableCell component="th">Date de paiement</TableCell>
                            <TableCell component="th">Option</TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.createSpendingList()}
                    </TableBody>
                </TableLayout>
            </Box>
            
        );
    }
}

export default SpendingList;